import type { init as initApm } from '@elastic/apm-rum';

export default function useElasticApm() {
  if (!import.meta.client) return null;
  return (useNuxtApp().vueApp?._context?.provides?.$apm ??
    useNuxtApp().vueApp?._instance?.appContext?.provides?.$apm) as ReturnType<
    typeof initApm
  >;
}
